// extracted by mini-css-extract-plugin
export var numberInputContainer = "_85-0";
export var startPickingButton = "_85-1";